import * as CONSTANTS from '../constants';
import React from 'react';
import Link from 'next/link';
import Router from 'next/router';
import { ModalContext } from '../context/modal';
import styled, { createGlobalStyle } from 'styled-components';
import { logEvent } from '../utils/analytics';
import fetch from 'isomorphic-unfetch';
import 'mdn-polyfills/String.prototype.includes';

const fetchOptions = {
  method: 'GET',
  cache: 'no-cache'
};

// TODO: add colelctions
// <PopoverNavListItem><PopoverNavLinkAnchor href="/auth/auth:twitter">Collections (sign in)</PopoverNavLinkAnchor></PopoverNavListItem>

const GlobalStyle = createGlobalStyle`
  body {
    background-color: ${props => (props.darkMode === true ? `${CONSTANTS.darkModeBackground}` : '#fff')} !important;

    ${props => (props.isModalOpen ? 'overflow: hidden;height: 100%;' : '')};
  }


  ${CONSTANTS.headStyles}
`;

let currentTagsSet = new Set();
let currentShadesSet = new Set();

const menuItemStyles = `
  font-size: 13px;
  margin: 0px 25px;
  color: ${CONSTANTS.darkGray};
  font-weight: 200;
  position: relative;
  cursor: pointer;

  @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {  
    height: 18px;
  }
`;

const menuItemHoverStyles = `
  color: ${CONSTANTS.mediumGray};
`;

const popoverNavTriggerStyles = `
  position: relative;
  display: inline-block;
  width:20px;
`;

const popoverNavTriggerTriangleStyles = `
  &::before {
    content: '';
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 10px 10px 10px;
    border-color: transparent transparent ${CONSTANTS.uglyGray} transparent;
    position: absolute;
    left: 0;
    right: 0;
    margin: 0 auto 0 auto;
    bottom: -18px;
    z-index: 2;
  }
`;

const filterTriggerStyles = `
  position: relative;
`;

const filterTriggerVisibleStyles = `
  &:before {
    content: '';
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 10px 10px 10px;
    border-color: transparent transparent ${CONSTANTS.uglyGray} transparent;
    position: absolute;
    left: 0;
    right: 0;
    margin: 0 auto 0 auto;
    bottom: -18px;
  }
`;

const popoverNavLinkStyles = `
  color: ${CONSTANTS.darkGray};
  width: 100%;
  margin: 0;
  padding: 15px;
  display: block;
  text-align: left;
  font-size: 13px;
  font-weight: 200;
  cursor: pointer;

  &:hover {
    color: ${CONSTANTS.mediumGray};
  }
`;

const filterGroupStyles = `
  margin: 0 auto;
  display: table;
`;

const HeaderWrap = styled.header`
  width: 100%;
  padding-top: 60px;
`;

const Logo = styled.a`
  display: table;
  margin: 0 auto;
  cursor: pointer;
`;

const MenuItemAnchor = styled.a`
  ${menuItemStyles}

  &:hover {
    ${menuItemHoverStyles}
  }

  ${
    props => props.isNew ? `
      &:after {
        content: 'NEW';
        position: absolute;
        top: -14px;
        right: -24px;
        background-color: ${CONSTANTS.green};
        color: ${CONSTANTS.darkGray}
        font-size: 8px;
        padding: 3px;
        font-weight: 200;
        border-radius: 3px;
      }
    ` : ''
  }
`;

const MenuItemButton = styled.button`
  ${menuItemStyles}
  outline: none;
  border: none;
  background: none;
  ${props => props.purpose === 'togglePopoverNav' ? popoverNavTriggerStyles : ''}
  ${props => (props.purpose === 'togglePopoverNav') && (props.visible === true) ? popoverNavTriggerTriangleStyles : ''}
  


  ${props => props.purpose === 'triggerFilters' ? filterTriggerStyles : ''}
  ${props => (props.purpose === 'triggerFilters') && (props.visible === true) ? filterTriggerVisibleStyles : ''}

  ${
    props => props.filterCounttt ? `
      &:after {
        content: '${props.filterCounttt}';
        position: absolute;
        top: -14px;
        right: -20px;
        background-color: #f0f0f0;
        color: ${CONSTANTS.darkGray};
        font-size: 8px;
        padding: 3px 6px;
        font-weight: 200;
        border-radius: 3px;
      }
    ` : ''
  }

  &:hover {
    ${menuItemHoverStyles}
  }

  @media (max-width: 355px) {
    margin: 0px 15px;
  };
`;

const PopoverIconFill = styled.path`

`;

const PopoverNav = styled.div`
  display: ${
    props => props.visible === true ? 'table' : 
    props.visible === false ? 'none' :
    ''
  };
  margin-top: 1px;
  padding: 15px 0;
  position: absolute;
  right: 0;
  z-index: 1;
`;

const PopoverNavIcon = styled.svg`
  vertical-align: bottom;

  &:hover {
    ${PopoverIconFill} {
      fill: ${CONSTANTS.mediumGray};
    }
  }
`;

const PopoverNavList = styled.ul`
  background-color: ${CONSTANTS.white};
  border: 1px solid ${CONSTANTS.uglyGray};
  border-radius: 3px;
  overflow: hidden;
`;

const PopoverNavListItem = styled.li`
  text-align: left;
  font-size: ${CONSTANTS.paragraphSize};

  &:not(:last-child) {
    border-bottom: 1px solid ${CONSTANTS.uglyGray};
  }
`;

const PopoverNavLinkAnchor = styled.a`
  ${popoverNavLinkStyles}
`;

const PopoverNavLinkButton = styled.button`
  ${popoverNavLinkStyles}
  
  ${props => props.checked ? `
    color: #ffde91 !important;
  ` : ''};
`;

const SearchForm = styled.form`
  display: ${
    props => props.visible === true ? 'block' : 
    props.visible === false ? 'none' :
    ''
  };
  position: absolute;
  width: 100%;
  background-color: ${CONSTANTS.white};
  height: 41px;
  left: 0;
  right: 0;
  margin: -34px auto 0 auto;
  border-bottom: 1px solid ${CONSTANTS.uglyGray};
  padding: 8px 16px 0 16px;
`;

const Filters = styled.div`
  display: ${
    props => props.visible === true ? 'table' : 
    props.visible === false ? 'none' :
    ''
  };
  border: 1px solid ${CONSTANTS.uglyGray};
  background-color: ${CONSTANTS.white};
  margin: 16px auto 0 auto;
  left: 0;
  right: 0;
  z-index: 1;
  border-radius: 3px;

  @media (max-width: 885px) {
    width: 95%;
  };

  @media (max-width: 800px) {
    width: 85%;
  };
`;

const ShadeFilters = styled.ul`
  padding: 0 0 0 10px;
  ${filterGroupStyles}
`;

const TagFilters = styled.ul`
  padding: 10px 0 0 10px;
  ${filterGroupStyles}
`;

const FilterItem = styled.li`
  float: left;
`;

const FilterLink = styled.a`
  float: left;
  font-size: 11px;
  font-weight: 200;
  padding: 3px 11px;
  display: block;
  margin: 0 10px 10px 0;
  border-radius: 3px;
  color: ${CONSTANTS.darkGray};
  
  ${
    props => (props.tag) ? `
      border: 1px solid ${CONSTANTS.uglyGray};
    ` : ''
  }

  ${
    props => (props.shade) ? `
      border: 1px solid ${CONSTANTS[props.shade]} !important;
    ` : ''
  }

  &.visible {
    color: ${CONSTANTS.white};
    ${
      props => ((props.shade)) ? 
        `
          background-color: ${CONSTANTS[props.shade]} !important;
          color: ${CONSTANTS.white} !important;
        ` : ''
    };

    ${
      props => ((props.tag)) ? 
        `
          background-color: #eee;
          border-color: #eee;
          color: ${CONSTANTS.darkGray};
        ` : ''
    };
  }

  &:hover {
    color: ${CONSTANTS.mediumGray} !important;
  }
`;

const SearchInput = styled.input`
  border: none;
  height: 30px;
  font-size: ${CONSTANTS.headingTiny};
  background: transparent;
  display: block;
  text-align: left;
  width: 100%;
  text-indent: 10px;
`;

const Menu = styled.nav`
  display: table;
  margin: 0 auto;
  text-align: center;
  padding-top: 15px;
  position: relative;

  ${MenuItemAnchor} {
    ${props => (props.darkMode === true) ? `
      color: ${CONSTANTS.darkModeWhite};
    ` : ''}
  }

  ${MenuItemButton} {
    ${props => (props.darkMode === true) ? `
      color: ${CONSTANTS.darkModeAppleGrayText};

      &:before {
        border-color: transparent transparent #242329 transparent;
      }

      &:after {
        color: #717171;
        border: 1px solid #242329;
        background-color: transparent;
      }

      &:hover {
        color: #444;
      }
    ` : ''}
  }

  ${PopoverIconFill} {
    ${props => (props.darkMode === true) ? `
      fill: ${CONSTANTS.darkModeAppleGrayText} !important;

      &:hover {
        fill: #444 !important;
      }
    ` : ''}
  }

  ${PopoverNavList} {
    ${props => (props.darkMode === true) ? `
      background-color: ${CONSTANTS.darkModeBackground};
    ` : ''}
  }

  ${Filters} {
    ${props => (props.darkMode === true) ? `
    background-color: ${CONSTANTS.darkModeBackground};
    border-color: #242329;
  ` : ''}
  }

  ${PopoverNavLinkAnchor} {
    ${props => (props.darkMode === true) ? `
    color: ${CONSTANTS.darkModeAppleGrayText};

    &:hover {
      color: #444;
    }
  ` : ''}
  }

  ${PopoverNavLinkButton} {
    ${props => (props.darkMode === true) ? `
    color: ${CONSTANTS.darkModeAppleGrayText};

    &:hover {
      color: #444;
    }
  ` : ''}
  }

  ${FilterLink} {
    ${props => (props.darkMode === true) ? `
    color: ${CONSTANTS.darkModeAppleGrayText};
    border-color: #242329;

    &:hover {
      color: #404040 !important;
    }
    
    &.visible{
      color: #fff !important;
      background-color: #1a1a1a;
      border: 1px solid #1a1a1a;
    }
  ` : ''}
  }

  ${SearchForm} {
    ${props => (props.darkMode === true) ? `
    background-color: ${CONSTANTS.darkModeBackground};
  ` : ''}
  }

  ${SearchInput} {
    ${props => (props.darkMode === true) ? `
    color: ${CONSTANTS.darkModeWhite};

    &::-webkit-input-placeholder {
      color: ${CONSTANTS.darkModeWhite};
    }
  ` : ''}
  }

  ${PopoverNavListItem} {
    ${props => (props.darkMode === true) ? `
    border-color: #242329;
  ` : ''}
  }

  ${SearchForm} {
    ${props => (props.darkMode === true) ? `
    border-bottom: 1px solid #242329;
  ` : ''}
  }

  ${SearchInput} {
    ${props => (props.darkMode === true) ? `
    color: #fff;
  ` : ''}
  }

  ${PopoverNavList} {
    ${props => (props.darkMode === true) ? `
    border-color: #242329;
  ` : ''}
  }
`;

export default class Header extends React.Component {
  constructor(props) {

    super(props);
    this.state = {
      isSearchVisible: false,
      isFiltersVisible: false,
      isPopoverNavVisible: false,
      darkMode: this.props.darkMode,
      filterCount: 0,
    };
    this.logoClick = this.logoClick.bind(this);
    this.showModal = this.showModal.bind(this);

    this.toggleDarkMode = this.toggleDarkMode.bind(this);
    this.toggleSearch = this.toggleSearch.bind(this);
    this.toggleFilter = this.toggleFilter.bind(this);
    this.toggleAllFilters = this.toggleAllFilters.bind(this);
    
    this.togglePopoverNav = this.togglePopoverNav.bind(this);
    this.handleSearchSubmit = this.handleSearchSubmit.bind(this);
    this.handleSearchBlur = this.handleSearchBlur.bind(this);
  }

  componentDidMount() {
    if(document.cookie.includes('darkMode=true')) {

      this.setState({
        darkMode: true,
      });

      this.context.updateValue('darkMode', true);
    }
    
    function getUrlParams(search) {
      let hashes = search.slice(search.indexOf('?') + 1).split('&')
      return hashes.reduce((params, hash) => {
          let [key, val] = hash.split('=')
          return Object.assign(params, {[key]: decodeURIComponent(val)})
      }, {})
    }

    const params = getUrlParams(window.location.search);

    if(params && params.shades) {
      const shades = params.shades.split(',');

      shades.forEach(shade => {
        const selector = document.querySelector(`[href="/?shade=${shade}"]`);
        selector.classList.add('visible');
        
        currentShadesSet.add(shade);
      });
    }

    if(params && params.tags) {
      const tags = params.tags.split(',');

      tags.forEach(tag => {
        const selector = document.querySelector(`[href="/?tag=${tag}"]`);
        selector.classList.add('visible');

        currentTagsSet.add(tag);
      });
    }

    if(params && (params.shades || params.tags)) {
      this.setState({
        isPopoverNavVisible: false,
        isSearchVisible: false,
        isFiltersVisible: true
      });
    }
	}

  componentDidUpdate(prevProps, prevState) {
    if (this.state.isSearchVisible === true) {
      this.searchInput.focus();
    }
  }

  logoClick(e) {
    e.preventDefault();

    currentShadesSet.clear();
    currentTagsSet.clear();

    const filters = document.querySelectorAll(`#filters a.visible`);

    if(filters) {
      filters.forEach(filter => {
        filter.classList.remove('visible');
      });
    }

    this.context.updateValue('currentSearch', 'resetToOriginalEntries');

    this.setState({
      isPopoverNavVisible: false,
      isSearchVisible: false,
      isFiltersVisible: false,
      filterCount: 0,
    });

    const href = '/';

    const as = href;
    Router.push(href, as, { shallow: true });
  }

  showModal(e, modalName) {
    e.preventDefault();

    this.context.updateValue('currentModal', modalName);
  }

  toggleDarkMode(e) {
      e.preventDefault();

      let newSetting;
      let darkModeStatus = false;

      if(this.state.darkMode === true) {
        newSetting = false;
        logEvent('dark mode', 'off');
      } else {
        newSetting = true;
        darkModeStatus = true;
        logEvent('dark mode', 'on');
      }

      this.setState({
        darkMode: newSetting,
        darkModeText: darkModeStatus
      });

      this.context.updateValue('darkMode', newSetting);

      const daysUntilExpiration = 30;

      const date = new Date();
      date.setTime(date.getTime()+(daysUntilExpiration*24*60*60*1000));

      const expires = (newSetting === true) ? `;expires=${date.toGMTString()}` : '';

      document.cookie = `darkMode=${newSetting}${expires}`;
  }

  toggleSearch(e) {
    this.setState({
      isSearchVisible: true,
      isFiltersVisible: false,
      isPopoverNavVisible: false
    });

    logEvent('search', 'show');
  }

  toggleAllFilters(e) {
    let newCLass = false;
    let filterCount = 0;

    if(this.state.isFiltersVisible === false) {
      newCLass = true;
      logEvent('filters', 'show');
    } else {
      filterCount = currentTagsSet.size + currentShadesSet.size;
      logEvent('filters', 'hide');
    }

    this.setState({
      isFiltersVisible: newCLass,
      isPopoverNavVisible: false,
      filterCount: filterCount,
    });

    const tags = Array.from(currentTagsSet).join(",");
    const shades = Array.from(currentShadesSet).join(",");

    let queryString;

    if(tags.length && shades.length) {
      queryString = `?tags=${tags}&shades=${shades}`;
    } else if(tags.length) {
      queryString = `?tags=${tags}`;
    } else if(shades.length) {
      queryString = `?shades=${shades}`;
    }

    if(!queryString) {
      queryString = '';
    }

    //this.props.history.push(`${queryString}`);

    fetch(`${CONSTANTS.API_URL}${queryString}`, fetchOptions).then(function(response) {
      if(response.status && response.status === 200) {
        response.text().then(function(text) {
          const newData = JSON.parse(text);

          this.context.updateValue('entryData', newData);

          const nextPageUrl = newData.nextPageUrl ? newData.nextPageUrl : undefined;

          this.context.updateValue('nextPageLink', nextPageUrl);

        }.bind(this));
      }
    }.bind(this));
  }

  toggleFilter(e, type) {
    e.preventDefault();

    if(e.target.classList.contains('visible')) {
      e.target.classList.remove('visible')
      
      if(type === 'tag') {
        currentTagsSet.delete(e.target.innerText);
        logEvent('filter | tag', 'remove');
      } else if(type === 'shade') {
        currentShadesSet.delete(e.target.innerText);
        logEvent('filter | shade', 'remove');
      }
    } else {
      e.target.classList.add('visible');

      if(type === 'tag') {
        currentTagsSet.add(e.target.innerText);
        logEvent('filter | tag', 'add');
      } else if(type === 'shade') {
        currentShadesSet.add(e.target.innerText);
        logEvent('filter | shade', 'add');
      }
    }

    const tags = Array.from(currentTagsSet).join(",");
    const shades = Array.from(currentShadesSet).join(",");
    let href = `/?tags=${tags}`;

    if(tags.length && shades.length) {
      href = `/?tags=${tags}&shades=${shades}`;
    } else if(tags.length) {
      href = `/?tags=${tags}`;
    } else if(shades.length) {
      href = `/?shades=${shades}`;
    } else {
      href = '/';
    }

    const as = href;
    Router.push(href, as, { shallow: true });

    fetch(`${CONSTANTS.API_URL}${href}`, fetchOptions).then(function(response) {
      if(response.status && response.status === 200) {
        response.text().then(function(text) {
          const newData = JSON.parse(text);

          this.context.updateValue('currentSearch', newData);

          const nextPageUrl = newData.nextPageUrl && newData.hasNextPage ? newData.nextPageUrl : undefined;

          this.context.updateValue('nextPageLink', nextPageUrl);
        }.bind(this));
      }
    }.bind(this));
  }

  togglePopoverNav(e) {
    let newState = false;

    if(this.state.isPopoverNavVisible === false) {
      newState = true;

      logEvent('popover nav', 'show');
    } else {
      logEvent('popover nav', 'hide');
    }

    this.setState({
      isPopoverNavVisible: newState,
      isSearchVisible: false,
      isFiltersVisible: false
    });
  }

  handleSearchSubmit(e) {
    e.preventDefault();

    logEvent('search', 'submit');

    const searchQuery = e.target.querySelector('input').value;

    if(searchQuery.length > 1) {
      const href = `/?search=${searchQuery}`;

      const as = href;
      Router.push(href, as, { shallow: true });

      currentShadesSet.clear();
      currentTagsSet.clear();

      const selectedFilters = document.querySelectorAll('li a.visible');

      selectedFilters.forEach(filter => {
        filter.classList.remove('visible');
      });

      fetch(`${CONSTANTS.API_URL}?search=${searchQuery}`, fetchOptions).then(function(response) {
        if(response.status && response.status === 200) {
          response.text().then(function(text) {
            const newData = JSON.parse(text);

            this.context.updateValue('currentSearch', newData);

            const nextPageUrl = newData.nextPageUrl && newData.hasNextPage ? newData.nextPageUrl : undefined;

            this.context.updateValue('nextPageLink', nextPageUrl);
            
          }.bind(this));
        }
      }.bind(this));

      e.target.querySelector('input').value = '';

      this.setState({
        searchBarClass: '',
      });
    } else {
      // this.props.searchcontrol('null');
    }
  }

  handleSearchBlur(e) {
    this.setState({
      isSearchVisible: false
    });

    logEvent('search', 'hide');
  }

  /*
  <Link href="/shop">
    <MenuItemAnchor id="shop" isNew={true}>Shop</MenuItemAnchor>
  </Link>
  */

  render() {
    return (
      <HeaderWrap>
        <GlobalStyle darkMode={this.state.darkMode} isModalOpen={this.context.currentModal} />
        <Link
          href="/"
        >
          <Logo href="/" onClick={(e) => this.logoClick(e)}>
            <img
              src={`https://d3alngem7je9z2.cloudfront.net/sitesee.svg`}
              height="53"
              alt="SiteSee logo"
            />
          </Logo>
        </Link>
        <Menu darkMode={this.state.darkMode}>
          <MenuItemButton id="search" onClick={(e) => this.toggleSearch(e)}>Search</MenuItemButton>
          <MenuItemButton purpose="triggerFilters" visible={this.state.isFiltersVisible} onClick={(e) => this.toggleAllFilters(e)} filterCounttt={this.state.filterCount}>Filter</MenuItemButton>
          <MenuItemButton id="submit" onClick={(e) => this.showModal(e, 'submission')}>Submit</MenuItemButton>
          <MenuItemButton aria-label="Secondary navigation" purpose="togglePopoverNav" visible={this.state.isPopoverNavVisible} onClick={(e) => this.togglePopoverNav(e)}>
            <PopoverNavIcon className="nav-icon" x="0px" y="0px" viewBox="-87 66 14 14" enableBackground="new -87 66 14 14"><PopoverIconFill className="icon-fill" fill="#3f3f3f" d="M-83.9,73c0,0.8-0.7,1.5-1.5,1.5s-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5S-83.9,72.2-83.9,73z M-74.6,71.5  c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5S-73.8,71.5-74.6,71.5z M-80,71.5c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5  s1.5-0.7,1.5-1.5S-79.2,71.5-80,71.5z"/></PopoverNavIcon>
          </MenuItemButton>
          <SearchForm visible={this.state.isSearchVisible} onSubmit={(e) => this.handleSearchSubmit(e)} id="searchForm" action="/" autoComplete="off">
            <SearchInput ref={(input) => { this.searchInput = input; }} onBlur={(e) => this.handleSearchBlur(e)} type="text" placeholder="Search for a site…" name="search" autoComplete="off" maxLength="60" />
          </SearchForm>
          <Filters aria-label="Filters" id="filters" visible={this.state.isFiltersVisible}>
            <TagFilters>
              <FilterItem>
                <FilterLink href="/?tag=agency" typeOfFilter="tag" tag="agency" onClick={(e) => this.toggleFilter(e, 'tag')}>agency</FilterLink>
              </FilterItem>
              <FilterItem>
                <FilterLink href="/?tag=app" typeOfFilter="tag" tag="app" onClick={(e) => this.toggleFilter(e, 'tag')}>app</FilterLink>
              </FilterItem>
              <FilterItem>
                <FilterLink href="/?tag=blog" typeOfFilter="tag" tag="blog" onClick={(e) => this.toggleFilter(e, 'tag')}>blog</FilterLink>
              </FilterItem>
              <FilterItem>
                <FilterLink href="/?tag=ecommerce" typeOfFilter="tag" tag="ecommerce" onClick={(e) => this.toggleFilter(e, 'tag')}>ecommerce</FilterLink>
              </FilterItem>
              <FilterItem>
                <FilterLink href="/?tag=event" typeOfFilter="tag" tag="event" onClick={(e) => this.toggleFilter(e, 'tag')}>event</FilterLink>
              </FilterItem>
              <FilterItem>
                <FilterLink href="/?tag=informational" typeOfFilter="tag" tag="informational" onClick={(e) => this.toggleFilter(e, 'tag')}>informational</FilterLink>
              </FilterItem>
              <FilterItem>
                <FilterLink href="/?tag=personal" typeOfFilter="tag" tag="personal" onClick={(e) => this.toggleFilter(e, 'tag')}>personal</FilterLink>
              </FilterItem>
              <FilterItem>
                <FilterLink href="/?tag=portfolio" typeOfFilter="tag" tag="portfolio" onClick={(e) => this.toggleFilter(e, 'tag')}>portfolio</FilterLink>
              </FilterItem>
              <FilterItem>
                <FilterLink href="/?tag=product" typeOfFilter="tag" tag="product" onClick={(e) => this.toggleFilter(e, 'tag')}>product</FilterLink>
              </FilterItem>
              <FilterItem>
                <FilterLink href="/?tag=resource" typeOfFilter="tag" tag="resource" onClick={(e) => this.toggleFilter(e, 'tag')}>resource</FilterLink>
              </FilterItem>
              <FilterItem>
                <FilterLink href="/?tag=service" typeOfFilter="tag" tag="service" onClick={(e) => this.toggleFilter(e, 'tag')}>service</FilterLink>
              </FilterItem>
            </TagFilters>
            <ShadeFilters>
              <FilterItem>
                <FilterLink href="/?shade=black" typeOfFilter="shade" shade="filter_black" onClick={(e) => this.toggleFilter(e, 'shade')}>black</FilterLink>
              </FilterItem>
              <FilterItem>
                <FilterLink href="/?shade=blue" typeOfFilter="shade" shade="filter_blue" onClick={(e) => this.toggleFilter(e, 'shade')}>blue</FilterLink>
              </FilterItem>
              <FilterItem>
                <FilterLink href="/?shade=brown" typeOfFilter="shade" shade="filter_brown" onClick={(e) => this.toggleFilter(e, 'shade')}>brown</FilterLink>
              </FilterItem>
              <FilterItem>
                <FilterLink href="/?shade=gray" typeOfFilter="shade" shade="filter_gray" onClick={(e) => this.toggleFilter(e, 'shade')}>gray</FilterLink>
              </FilterItem>
              <FilterItem>
                <FilterLink href="/?shade=green" typeOfFilter="shade" shade="filter_green" onClick={(e) => this.toggleFilter(e, 'shade')}>green</FilterLink>
              </FilterItem>
              <FilterItem>
                <FilterLink href="/?shade=orange" typeOfFilter="shade" shade="filter_orange" onClick={(e) => this.toggleFilter(e, 'shade')}>orange</FilterLink>
              </FilterItem>
              <FilterItem>
                <FilterLink href="/?shade=pink" typeOfFilter="shade" shade="filter_pink" onClick={(e) => this.toggleFilter(e, 'shade')}>pink</FilterLink>
              </FilterItem>
              <FilterItem>
                <FilterLink href="/?shade=purple" typeOfFilter="shade" shade="filter_purple" onClick={(e) => this.toggleFilter(e, 'shade')}>purple</FilterLink>
              </FilterItem>
              <FilterItem>
                <FilterLink href="/?shade=red" typeOfFilter="shade" shade="filter_red" onClick={(e) => this.toggleFilter(e, 'shade')}>red</FilterLink>
              </FilterItem>
              <FilterItem>
                <FilterLink href="/?shade=white" typeOfFilter="shade" shade="filter_white" onClick={(e) => this.toggleFilter(e, 'shade')}>white</FilterLink>
              </FilterItem>
              <FilterItem>
                <FilterLink href="/?shade=yellow" typeOfFilter="shade" shade="filter_yellow" onClick={(e) => this.toggleFilter(e, 'shade')}>yellow</FilterLink>
              </FilterItem>
            </ShadeFilters>
          </Filters>
          <PopoverNav visible={this.state.isPopoverNavVisible}>
            <PopoverNavList aria-label="Secondary navigation">
              <PopoverNavListItem><PopoverNavLinkButton onClick={(e) => {this.showModal(e, 'newsletter');logEvent('popover nav click', 'subscribe')}}>Newsletter</PopoverNavLinkButton></PopoverNavListItem>
              <PopoverNavListItem><PopoverNavLinkAnchor onClick={(e) => {logEvent('popover nav click', 'chrome extension')}} href="https://chrome.google.com/webstore/detail/sitesee-web-design-inspir/hnpkjoifldafgenlhognhkfjbpglbmmp" target="_blank" rel="noopener noreferrer">Chrome Extension</PopoverNavLinkAnchor></PopoverNavListItem>
              <PopoverNavListItem><PopoverNavLinkAnchor onClick={(e) => {logEvent('popover nav click', 'twitter')}} href="https://twitter.com/siteseegallery" target="_blank" rel="noopener noreferrer">Twitter</PopoverNavLinkAnchor></PopoverNavListItem>
              <PopoverNavListItem><PopoverNavLinkButton onClick={(e) => {this.toggleDarkMode(e)}} checked={this.state.darkMode}>Dark mode</PopoverNavLinkButton></PopoverNavListItem>
            </PopoverNavList>
          </PopoverNav>
        </Menu>
      </HeaderWrap>
    )
  }
}

Header.contextType = ModalContext;